(function () {
  'use strict';

  angular
    .module('app.behavior-analytics')
    .service('behaviorAnalyticsService', behaviorAnalyticsService);

  /* @ngInject */
  function behaviorAnalyticsService($http, helperService) {
    /* jshint validthis: true */
    var vm = this;

    vm.quickview = quickview;
    vm.subjectGradeComparisons = subjectGradeComparisons;
    vm.teacherComparisons = teacherComparisons;
    vm.teacherDetails = teacherDetails;

    ////////////

    function quickview(filters) {
      // prepare filters

      return $http.get('/api/analytics/behavior/quickview', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function subjectGradeComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/behavior/subject-grade-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherComparisons(filters) {
      // prepare filters

      return $http.get('/api/analytics/behavior/teacher-comparisons', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }

    function teacherDetails(filters) {
      // prepare filters

      return $http.get('/api/analytics/behavior/teacher-details', {params: filters})
        .then(helperService.handleResponse)
        .then(function (data) {
          // Prepare data before view

          return data;
        });
    }
  }
})();